import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { AppearanceService } from '../../services/appearance/appearance.service';
import { ModalController } from '@ionic/angular';
import { Constants } from '../../constants/constants';
import { ClientService } from 'src/app/services/client/client.service';
import { JobService } from 'src/app/services/job/job.service';
import { ConditionReportModel } from 'src/app/models/condition-report.model';
import { AssetService } from 'src/app/services/asset/asset.service';
import { ModalImageUploadComponent } from '../modal-image-upload/modal-image-upload.component';



@Component({
  selector: 'modal-new-condition',
  templateUrl: './modal-new-condition.component.html',
  styleUrls: ['./modal-new-condition.component.scss'],
})
export class ModalNewConditionReportComponent implements OnInit {

  segment: string = 'default';
  assetUid: string;
  isStreetLight: boolean = false;
  newCondition: ConditionReportModel;




  constructor(public appearanceService: AppearanceService, public jobService: JobService,
   public userService: UserService, private modalControllerTwo: ModalController, 
   public assetService: AssetService, public clientService: ClientService) {

  }


  ngOnInit() 
  {

  }


  // TODO - This is kind of identical to ModalAddAssetConditionComponent just that has an extra name?

  ionViewWillEnter()
  {
    this.newCondition = new ConditionReportModel();

    this.newCondition.assetName     = "";
    this.newCondition.summary       = "Good";
    this.newCondition.approxAge     = "15 - 25";
    this.newCondition.columnType    = null;
    this.newCondition.headType      = null;
    this.newCondition.notes         = "";
    this.newCondition.assetUid      = Number(this.assetUid);
    this.newCondition.clientUid     = this.clientService.getClientUid();

    if (this.isStreetLight)
    {
      this.newCondition.columnType  = "Steel";
      this.newCondition.headType    = "Beta Style";
    }
  }


  ionViewWillLeave() 
  {

  }


  clearAll()
  {
    this.newCondition = new ConditionReportModel();
  }


  closeModal(returnData = null)
  {
    this.modalControllerTwo.dismiss(returnData, null, 'NewConditionModal');
  }


  deletePhoto(index)
  {
    this.newCondition.photos[index] = null;
  }


  async addPhoto(index) 
  {
    const modalTwo = await this.modalControllerTwo.create({
      component: ModalImageUploadComponent,
      backdropDismiss: false,
      componentProps: { 
        jobAssetUid: null,
        jobUid: null,
        uploadUrl: null
      },
      cssClass: 'ninety8-screen-modal',
      id: 'ImageUploadModal'
    });

    modalTwo.onDidDismiss().then((response) => {

      if (response.data)
      {
        if (response.data.addedFile)
        {
          this.newCondition.photos[index] = response.data.addedFile;
        }
      }
    })

    return await modalTwo.present();
  }


  save()
  {
    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.createAssetConditionReport(this.newCondition).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          var returnData = { reload: true };
          this.closeModal(returnData);
          this.appearanceService.presentToast("Saved.", Constants.TOAST_SUCCESS);
        }
        else
        {
            this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);
      });
    });
  }
}